        document.addEventListener('DOMContentLoaded', function() {
            const form = document.querySelector('.origin-contact-form-container form');
            const submitButton = form.querySelector('button[type="submit"]');
            const successMessage = document.querySelector('.success-message');
            const errorMessage = document.querySelector('.error-message');
            
            // Rate limiting variables
            const RATE_LIMIT_KEY = 'celestron_form_last_submit';
            const RATE_LIMIT_MINUTES = 1; // Don't allow resubmission within 5 minutes
            
            // Check if user has submitted recently
            function checkRateLimit() {
                const lastSubmit = localStorage.getItem(RATE_LIMIT_KEY);
                if (lastSubmit) {
                    const timeSinceLastSubmit = Date.now() - parseInt(lastSubmit);
                    const minutesSinceLastSubmit = timeSinceLastSubmit / (1000 * 60);
                    
                    if (minutesSinceLastSubmit < RATE_LIMIT_MINUTES) {
                        const remainingMinutes = Math.ceil(RATE_LIMIT_MINUTES - minutesSinceLastSubmit);
                        return {
                            allowed: false,
                            remainingMinutes: remainingMinutes
                        };
                    }
                }
                return { allowed: true };
            }
            
            form.addEventListener('submit', async function(e) {
                e.preventDefault();
                
                // Check rate limit
                const rateLimitCheck = checkRateLimit();
                if (!rateLimitCheck.allowed) {
                    errorMessage.textContent = `Please wait ${rateLimitCheck.remainingMinutes} more minute(s) before submitting again.`;
                    errorMessage.style.display = 'block';
                    successMessage.style.display = 'none';
                    return;
                }
                
                // Disable submit button to prevent double submission
                submitButton.disabled = true;
                submitButton.textContent = 'Submitting...';
                
                // Get form data
                const formData = {
                    firstName: document.getElementById('firstName').value,
                    lastName: document.getElementById('lastName').value,
                    email: document.getElementById('email').value,
                    country: document.getElementById('country').value,
                    streetAddress: document.getElementById('streetAddress').value,
                    zipcode: document.getElementById('zipcode').value,
                    phone: document.getElementById('phone').value,
                    serialNumber: document.getElementById('serialNumber').value,
                    formType: document.getElementById('formType').value
                };
                
                console.log('Form data being sent:', formData); // Debug log
                
                try {
                    // Submit to PHP endpoint
                    const response = await fetch('https://celestron-support-contact-f9a2d4afec91.herokuapp.com/origin-upgrade-path.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(formData)
                    });
                    
                    const result = await response.json();
                    
                    if (response.ok && result.success) {
                        // Store submission timestamp for rate limiting
                        localStorage.setItem(RATE_LIMIT_KEY, Date.now().toString());
                        
                        // Show success message
                        successMessage.style.display = 'block';
                        errorMessage.style.display = 'none';
                        form.reset();
                        
                        // Hide success message after 5 seconds
                        setTimeout(() => {
                            successMessage.style.display = 'none';
                        }, 5000);
                    } else {
                        throw new Error(result.message || 'Submission failed');
                    }
                } catch (error) {
                    // Show error message
                    errorMessage.textContent = 'There was an error submitting the form. Please try again.';
                    errorMessage.style.display = 'block';
                    successMessage.style.display = 'none';
                    console.error('Error:', error);
                } finally {
                    // Re-enable submit button
                    submitButton.disabled = false;
                    submitButton.textContent = 'Submit';
                }
            });
        });